import React, { useState } from 'react';
import styled from 'styled-components';

const DropContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
`;

const DropNome = styled.span`
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: #222;
    display: flex;
    align-items: center;
    gap: 4px;
`;

const DropSeta = styled.button`
    display: flex;
    align-items: center;
    margin-left: 4px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    transition: transform 0.2s;
    transform: ${({ aberto }) => aberto ? 'rotate(180deg)' : 'none'};
`;

const DropEmail = styled.div`
    font-size: 13px;
    color: #555;
    padding: 2px 15px;
    margin-top: 2px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const SetaIcone = () => (
    <svg width="8" height="6" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.00726 7.61142L12.7923 1.82625C12.9262 1.69245 13 1.51383 13 1.32338C13 1.13293 12.9262 0.954309 12.7923 0.820505L12.3664 0.394468C12.0888 0.117243 11.6378 0.117243 11.3606 0.394468L6.5027 5.25241L1.63936 0.389077C1.50545 0.255273 1.32694 0.181396 1.13659 0.181396C0.946033 0.181396 0.767523 0.255273 0.633508 0.389077L0.207682 0.815114C0.0737724 0.949024 9.12317e-07 1.12753 9.03992e-07 1.31799C8.95667e-07 1.50844 0.0737724 1.68706 0.207682 1.82086L5.99802 7.61142C6.13236 7.74554 6.31171 7.8192 6.50238 7.81878C6.69378 7.81921 6.87303 7.74554 7.00726 7.61142Z" fill="black" />
    </svg>
);

const UsuarioDrop = ({ nome, email, telefone, congregacao, circuito }) => {
    const [aberto, setAberto] = useState(false);

    return (
        <DropContainer>
            <DropNome>
                <DropSeta
                    aberto={aberto}
                    onClick={() => setAberto(a => !a)}
                    aria-label={aberto ? "Ocultar e-mail e telefone" : "Mostrar e-mail e telefone"}
                    tabIndex={0}
                >
                    <SetaIcone />
                </DropSeta>
                {nome}
            </DropNome>
            {aberto && (
                <DropEmail>
                    <div>{email}</div>
                    <div>{telefone}</div>
                    <div>{congregacao}</div>
                    <div>{circuito}</div>
                </DropEmail>
            )}
        </DropContainer>
    );
};

export default UsuarioDrop;